<template>
  <div class="page">
    <el-header>
      <topbar></topbar>
    </el-header>
    <div class="page-body">
      <sidebar></sidebar>
      <div class="content">
        <transition name="moveInUp">
          <router-view />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/layout/Sidebar";
import Topbar from "@/components/layout/Topbar";
import storage from "@/components/utils/storage";

export default {
  components: {
    sidebar: Sidebar,
    topbar: Topbar,
  },
  mounted() {
    this.authenticated = storage.loadAuthenticated();
    if (this.authenticated === null || this.authenticated === "false") {
      this.$router.replace({ name: "login" });
    }
  },
  data() {
    return {
      authenticated: false,
    };
  },
};
</script>

<style>
html,
body {
  margin: 0;
  height: 100%;
}

#app {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.page {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.el-header {
  background-color: #ffffff !important;
  padding: 0 !important;
  height: auto !important;
  flex-shrink: 0;
}

.page-body {
  flex: 1;
  display: flex;
  flex-direction: row;
  min-height: 0;
  overflow: hidden;
}

.content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-width: 0;
}

.content::-webkit-scrollbar {
  width: 6px;
}

.content::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 3px;
}

.moveInUp-enter-active {
  opacity: 0;
  transition: opacity 1s ease-in;
}

.tabla {
  position: relative;
  margin-left: -1px;
  margin-top: 16px;
  height: 100%;
}

.v-modal {
  display: none;
}
</style>
